const useComponentDefaultProps = <T, U extends Partial<T>>(deafult_props: U, props: T): T => {
  return { ...deafult_props, ...props };
};

export default useComponentDefaultProps;
